import {Component, DestroyRef, Inject, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {filter, map, Observable, tap} from 'rxjs';
import {DataReportCategory,} from '../../repository/entity/dashboard.entity';
import {DashboardService} from '../../service/dashboard.service';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {BranchService} from "../../../branch/branch.service";

export interface DialogData {
  title: string;
}

@Component({
  selector: 'app-dialog-filter',
  templateUrl: './dialog-filter.component.html',
  styleUrl: './dialog-filter.component.scss',
})
export class DialogFilterComponent implements OnInit {
  public destroyRef = inject(DestroyRef);
  public reportCategories$: Observable<DataReportCategory[]>;
  public form: FormGroup;
  public branchOptions: string[];
  public menuOptions: { menuId: number, menuName: string }[] = [];
  public dropdownSettings: any = {};
  public dropdownMenuSettings: any = {};
  public selectedBranches: string[] = [];
  public selectedMenus: { menuId: number, menuName: string }[] = [];
  public disabledDropDownMenu: boolean = false;
  public category: string = "venue";

  constructor(
    public dialogRef: MatDialogRef<DialogFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private fb: FormBuilder,
    private dashboardService: DashboardService,
    private branchService: BranchService
  ) {
  }

  ngOnInit() {
    this.reportCategories$ = this.dashboardService.reportCategory;
    this.initDropDownSetting();
    this.initDropDownMenuSetting();

    this.initValueForm(["venue"], ["GU7"], []);
    this.branchService.getAllBranchObs()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map(branches => {
          return branches.map(b => b.branchCode)
            .filter(b => b === "GU7");
        }),
      ).subscribe(branchOptions => this.branchOptions = branchOptions);

    this.dashboardService.filterDate
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(filterData => {
        const selectedBranch = filterData.branch ? [filterData.branch] : ["GU7"];
        this.form.get('reportCategory')?.setValue(filterData.reportCategory);
        this.form.get('branch')?.setValue(selectedBranch);
        this.selectedBranches = selectedBranch;

        this.dashboardService.listMenu
          .pipe(
            takeUntilDestroyed(this.destroyRef),
            tap(menu => {
              this.menuOptions = menu.map(m => {
                return {
                  menuId: m.menuId,
                  menuName: m.menuName
                }
              });
            }),
            map(menu => ({
              menu,
              menuIdsArr: filterData.menuIds?.split(",").map(Number)
            })),
            map(({menu, menuIdsArr}) => menu.filter(m => menuIdsArr?.includes(m.menuId))),
            filter(filterMenu => filterMenu.length > 0),
            map(filterMenu => filterMenu.map(menu => ({menuId: menu.menuId, menuName: menu.menuName})))
          )
          .subscribe(selectedMenus => {
            this.selectedMenus = selectedMenus;
            this.form.get('menu')?.setValue(this.selectedMenus);
          });


        const category = filterData.reportCategory ? filterData.reportCategory : "venue";
        this.onCheckDropDownMenuShouldDisable(category)
      });

    this.form.get('reportCategory')?.valueChanges
      .pipe(takeUntilDestroyed((this.destroyRef)))
      .subscribe(category => this.onCheckDropDownMenuShouldDisable(category));

  }

  onClickOk() {
    const {reportCategory} = this.form.value;
    const joinBranches = this.selectedBranches.join(",");
    const menuIds = this.selectedMenus.map(m => m.menuId).join(",");

    this.dialogRef.close({reportCategory, branch: joinBranches, menuIds})
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  onItemSelect(item: any) {
    this.selectedBranches.push(item);
  }

  onItemDeSelect(item: any) {
    this.selectedBranches = this.selectedBranches.filter(branchCode => branchCode !== item);
  }

  onMenuSelect(item: any) {
    this.selectedMenus.push(item);
  }

  onMenuDeSelect(item: any) {
    this.selectedMenus = this.selectedMenus.filter(menu => menu.menuId !== item.menuId);
  }

  onDisableButtonApply() {
    const disableCategoryVenue = this.selectedBranches.length === 0;
    const disableCategoryMenu = this.selectedMenus.length === 0 && this.category === "menu";
    return disableCategoryVenue || disableCategoryMenu;
  }

  private initValueForm(reportCategory: string[], branch: string[], menu: { menuId: number, menuName: string }[]) {
    this.form = this.fb.group({reportCategory, branch, menu});
  }

  private initDropDownSetting() {
    this.dropdownSettings = {
      singleSelection: false,
      allowSearchFilter: true,
      enableCheckAll: false,
    };
  }

  private initDropDownMenuSetting() {
    this.dropdownMenuSettings = {
      singleSelection: false,
      allowSearchFilter: true,
      enableCheckAll: false,
      limitSelection: 10,
      idField: 'menuId',
      textField: 'menuName',
    };
  }

  private onCheckDropDownMenuShouldDisable(category: string) {
    this.disabledDropDownMenu = category === "venue";
    this.selectedMenus = category === "venue" ? [] : this.selectedMenus;
    this.form.get('menu')?.setValue(this.selectedMenus);
    this.category = category;
  }

}
